import { useEffect } from "react";
import { useTenant } from "@/contexts/TenantContext";
import { trackPageView } from "@/lib/analytics";
import { SEO, SEOPresets } from "@/components/shared/SEO";
import { HeroSection } from "@/components/landing/HeroSection";
import { BookingWidget } from "@/components/landing/BookingWidget";
import { PopularRoutes } from "@/components/landing/PopularRoutes";
import { TrustSection } from "@/components/landing/TrustSection";
import { EnhancedHeader } from "@/components/layout/EnhancedHeader";
import { EnhancedFooter } from "@/components/layout/EnhancedFooter";

/**
 * Search Home Page - Main landing page for public booking
 * Displays tenant branding and trip search form
 */
export function SearchHomePage() {
  const { slug } = useTenant();

  // Track page view
  useEffect(() => {
    if (slug) {
      trackPageView("search_home", slug);
    }
  }, [slug]);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <SEO {...SEOPresets.search} />

      {/* Enhanced Header with logo, phone, and language selector */}
      <EnhancedHeader />

      {/* Hero Section with Video Background */}
      <HeroSection>
        <BookingWidget />
      </HeroSection>

      {/* Popular Routes Section */}
      <PopularRoutes />

      {/* Trust/Payment Section */}
      <TrustSection />

      {/* Enhanced Footer */}
      <EnhancedFooter />
    </div>
  );
}

export default SearchHomePage;
